import request from './https'
//首页轮播图和推荐数据
export const home = () => { return request('post', 'api/index/index') }
//分类默认数据
export const sort = () => { return request('post', '/api/index/alllist') }
//分类每一项数据
export const sortItem = (data) => { return request('post', '/api/index/list_p', data) }
//分类子集列表数据
export const searc_all = (data) => { return request('post', '/api/index/searc_all', data) }
//用户登录
export const login = (data) => { return request('post', '/api/login/registered', data) }
//获取验证码
export const send = (data) => { return request('post', '/api/login/send', data) }
//上传头像
export const user_img = (data) => { return request('post', '/api/login/userpic', data) }
//完善信息
export const improve = (data) => { return request('post', '/api/login/improve', data) }
//添加收货地址
export const add_address = (data) => { return request('post', '/api/index/add_address', data) }
//收货地址
export const address = (data) => { return request('post', '/api/index/address', data) }
//订单列表
export const order_list = (data) => { return request('post', '/api/index/order', data) }
//我的推荐
export const my = (data) => { return request('post', '/api/index/my', data) }
//商品详情
export const shops_info = (data) => { return request('post', '/api/index/info', data) }
//支付宝支付
export const zfb_pay = (data) => { return request('post', '/api/pay/pay', data) }
//删除地址
export const del_address = (data) => { return request('post', '/api/index/address', data) }